import { GetTranslation } from '../../translations/GetTranslation';
import CustomDraggableDialog from '../common/customDialog/CustomDraggableDialog';
import CustomSelect, { OptionType } from '../common/customSelect/CustomSelect';
import TranslatedMessage from '../translations/TranslatedMessage';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Switch from '@material-ui/core/Switch';
import React from 'react';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import { ActionMeta, ValueType } from 'react-select';

type IInvitationDialogProps = {
  onAccept: () => void,
  onCancel: () => void,
  onRadioButtonChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
  onSwitchChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
  onLocationChange: (selectedElements: ValueType<OptionType>, actionMeta?: ActionMeta<OptionType>) => void,
  isAllSelected: boolean,
  isInvitationDialogOpen: boolean,
  selectionValue: string,
  locations: OptionType[],
  selectedLocations: OptionType[],
} & WrappedComponentProps;

const InvitationDialog: React.FunctionComponent<IInvitationDialogProps> = (
  { onAccept, onCancel, onRadioButtonChange, onSwitchChange, onLocationChange, isAllSelected, isInvitationDialogOpen, selectionValue, locations, selectedLocations, intl }) => {
  return (
    <CustomDraggableDialog
      acceptText={<TranslatedMessage id="common.accept" />}
      cancelText={<TranslatedMessage id="common.cancel" />}
      content={
        <React.Fragment>
          <FormControl component="fieldset">
            <RadioGroup aria-label="personType" name="personType1" value={selectionValue} onChange={onRadioButtonChange}>
              <FormControlLabel value="expert" control={<Radio />} label={GetTranslation(intl, "expert.header")} />
              <FormControlLabel value="candidate" control={<Radio />} label={GetTranslation(intl, "candidate.header")} />
            </RadioGroup>
          </FormControl>
          <FormControlLabel
            control={
              <Switch
                checked={isAllSelected}
                onChange={onSwitchChange}
              />
            }
            label={<TranslatedMessage id="examSession.invitation.allLocations" />}
          />
          {!isAllSelected &&
            <CustomSelect
              label={<TranslatedMessage id="examSession.invitation.selectLocations" />}
              name={GetTranslation(intl, "examSession.invitation.selectLocations")}
              placeholder={<TranslatedMessage id="examSession.invitation.selectLocations" />}
              isMulti={true}
              options={locations}
              value={selectedLocations}
              onChange={onLocationChange} />}
        </React.Fragment>
      }
      isOpen={isInvitationDialogOpen}
      onAccept={onAccept}
      onCancel={onCancel}
      title={<TranslatedMessage id="examSession.invitation" />} />
  );
}

export default injectIntl(InvitationDialog);
